import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import apiClient from "../api/apiClient";
import Select from "react-select";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts?.default?.vfs || pdfFonts.vfs;


const PlanifLines = () => {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [entDate, setEntDate] = useState("");
    const [serviceType, setserviceType] = useState("");
    const [project, setproject] = useState("");
    const [servicesType, setServicesType] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [projects, setProjects] = useState([]);
    const [start_route, setStartRoute] = useState("");
    const [end_route, setEndRoute] = useState("");

     // Obtener la lista de artículos desde el backend
    const fetchItems = async () => {
        try {
            const responsePro = await apiClient.get("/sales-orders/projects");
            
            // Valores estáticos
            const staticItems = [
                { value: "DM", label: "Desayuno/Merienda" },
                { value: "AC", label: "Almuerzo/Cena" },
            ];
            setServicesType(staticItems);

            if (!Array.isArray(responsePro.data)) {
                throw new Error("Los datos recibidos no son un array");
            }
            // Formatear los Proyectos para el select
            const formattedProjects = responsePro.data.map((item) => ({
                value: item.PrjCode,
                label: `${item.PrjName}`,
            }));
            setProjects(formattedProjects);

        } catch (err) {
            console.error("Error obteniendo artículos", err);
            setError("Error al obtener los artículos.");
        }
    };

    // Función para obtener datos desde el backend
    const fetchInsumos = async () => {
        setLoading(true);
        const sapUser = JSON.parse(localStorage.getItem("sapUser"));
        const Company = sapUser?.CompanyDB || "";
        try {
            const response = await apiClient.get("/planif/consolidado", {
                params: { project: project?.value || "", servicio: serviceType?.value || "",  start_route, start_route, entDate, company: Company }
            });

            console.log("Datos recibidos:", response.data);

            if (!Array.isArray(response.data)) {
                throw new Error("Los datos recibidos no son un array");
            }

            // Aplicar agrupación según la opción seleccionada
            const groupedData = response.data.reduce((acc, order) => {
                let key;
                    key = `${order.Project}`;


                if (!acc[key]) {
                    acc[key] = {
                        Project: order.Project,
                        Gobernacion: order.CardName,
                        FechaEntrega: order.DocDueDate,
                        RutaIni: start_route,
                        RutaFin: end_route,
                        Orders: [],
                    };
                }
                acc[key].Orders.push(order);
                return acc;
            }, {});

            const formattedData = Object.values(groupedData);
            setOrders(formattedData);
            setFilteredOrders(formattedData);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching orders", err);
            setError("Error al obtener órdenes de ventas.");
        }
    };
    
    // 🔍 Filtrado dinámico
    useEffect(() => {
        fetchItems();
        if (!searchTerm) {
            setFilteredOrders(orders);
            return;
        }

        const filteredData = orders.filter((order) =>
            (order.CardName ? order.CardName.toLowerCase() : "").includes(searchTerm.toLowerCase()) || 
            (order.Name ? order.Name.toLowerCase() : "").includes(searchTerm.toLowerCase())
        );

        setFilteredOrders(filteredData);
    }, [searchTerm, orders]);

    // Componente expandible para mostrar líneas de orden
    const ExpandedComponent = ({ data }) => {
    // Agrupar y sumar cantidades
        const groupedItems = data.Orders.reduce((acc, item) => {
            const key = `${item.ItemCode}|${item.Dscription}|${item.SalUnitMsr}`;
            if (!acc[key]) {
                acc[key] = {
                    ItemCode: item.ItemCode,
                    Dscription: item.Dscription,
                    SalUnitMsr: item.SalUnitMsr,
                    Quantity: 0,
                };
            }
            acc[key].Quantity += parseFloat(item.Quantity) || 0;
            return acc;
        }, {});

        const rows = Object.values(groupedItems);

        return (
            <div className="p-2" style={{ width: "100%" }}>
                <h6 style={{ fontSize: "14px" }}>Resumen de Insumos</h6>
                <div style={{ overflowX: "auto", width: "100%" }}>
                    <div style={{ minWidth: "1000px" }}>
                        <table
                            className="table table-sm table-bordered"
                            style={{
                                fontSize: "14px",
                                width: "100%",
                                whiteSpace: "nowrap",
                                tableLayout: "auto",
                            }}
                        >
                            <thead>
                                <tr>
                                    <th style={{ minWidth: "50px" }}>Insumo</th>
                                    <th style={{ minWidth: "200px" }}>Descripción</th>
                                    <th style={{ minWidth: "120px", textAlign: "right" }}>Total Cantidad</th>
                                    <th style={{ minWidth: "300px" }}>Unidad de Medida</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.ItemCode}</td>
                                        <td>{item.Dscription}</td>
                                        <td style={{ textAlign: "right" }}>
                                            {item.Quantity.toLocaleString("es-ES")}
                                        </td>
                                        <td>{item.SalUnitMsr}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };

    const exportarPDF = () => {
        const fechaHoy = new Date().toLocaleDateString("es-PY");
        const datos = orders.flatMap(o => o.Orders);

        const grouped = datos.reduce((acc, item) => {
            const key = `${item.ItemCode}|${item.Dscription}|${item.SalUnitMsr}`;
            if (!acc[key]) {
                acc[key] = {
                    ItemCode: item.ItemCode,
                    Dscription: item.Dscription,
                    SalUnitMsr: item.SalUnitMsr,
                    Quantity: 0,
                };
            }
            acc[key].Quantity += parseFloat(item.Quantity) || 0;
            return acc;
        }, {});

        const rows = Object.values(grouped);

        let checklistItems = [];

        // 1. Recolectar datos únicos con U_Serv
        orders.forEach(o => {
            o.Orders.forEach(line => {
                const key = `${line.DocNum}|${line.Name}|${line.U_Serv}`;
                if (!checklistItems.some(i => `${i.DocNum}|${i.Name}|${i.U_Serv}` === key)) {
                    checklistItems.push({
                        DocNum: line.DocNum,
                        Name: line.Name,
                        U_Serv: line.U_Serv
                    });
                }
            });
        });

        // 2. Ordenar por U_Serv y luego DocNum
        checklistItems.sort((a, b) => {
            if (a.U_Serv === b.U_Serv) {
                return a.DocNum.toString().localeCompare(b.DocNum.toString());
            }
            return a.U_Serv.localeCompare(b.U_Serv);
        });

        const content = [
            { text: "PRODUCTOS CONSOLIDADOS", bold: true, fontSize: 16, margin: [0, 0, 0, 10] },
            { text: `Gobernación: ${orders[0]?.Gobernacion || ""}`, fontSize: 12 },
            { text: `Ruta: ${start_route}`, fontSize: 12 },
            { text: `Fecha de Entrega: ${entDate}`, fontSize: 12 },
            { text: "\n" },
            {
                table: {
                    headerRows: 1,
                    widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto'],
                    body: [
                        [
                            { text: 'Producto', bold: true },
                            { text: 'Descripción', bold: true },
                            { text: 'UM', bold: true },
                            { text: 'Cantidad Total', bold: true },
                            { text: 'Nro. de Lote', bold: true },
                            { text: 'Peso Total', bold: true },
                        ],
                        ...rows.map(row => ([
                            row.ItemCode,
                            row.Dscription,
                            row.SalUnitMsr,
                            row.Quantity.toLocaleString("es-ES"),
                            entDate,
                            "", // columna vacía para completar a mano o calcular luego
                        ]))
                    ]
                },
                fontSize: 11,
            },
            { text: "Checklist de Entrega por Escuela", bold: true, fontSize: 11, margin: [0, 10, 0, 4], pageBreak: 'before' },
            {
                table: {
                    headerRows: 1,
                    widths: ['auto', '*', 'auto', 'auto'],
                    body: [
                        [
                            { text: "DocNum", bold: true },
                            { text: "Escuela", bold: true },
                            { text: "Servicio", bold: true },
                            { text: "Check", bold: true }
                        ],
                        ...checklistItems.map(item => ([
                            item.DocNum,
                            item.Name,
                            item.U_Serv,
                            ""
                        ]))
                    ]
                },
                fontSize: 12,
            }
        ];

        // Fecha y hora de impresión en zona horaria America/Asuncion (GMT-03:00)
        const printedAt = new Date().toLocaleString("es-PY", {
            timeZone: "America/Asuncion",
            day: "2-digit", month: "2-digit", year: "numeric",
            hour: "2-digit", minute: "2-digit", second: "2-digit",
            hour12: false,
        });

        const docDefinition = {
            content,
            pageOrientation: 'portrait',
            pageMargins: [40, 55, 40, 40],
            header: (currentPage, pageCount) => ({
                columns: [
                    {
                        text: `Impreso: ${printedAt} (America/Asuncion, GMT-03:00)`,
                        alignment: 'left',
                        fontSize: 7,
                        color: '#555555',
                        margin: [40, 15, 0, 0],
                    },
                    {
                        text: `Página ${currentPage} de ${pageCount}`,
                        alignment: 'right',
                        fontSize: 7,
                        color: '#555555',
                        margin: [0, 15, 40, 0],
                    },
                ],
            }),
            defaultStyle: {
                fontSize: 8
            }
        };

        pdfMake.createPdf(docDefinition).open();
    };



    const columns = [
        {
            name: "Proyecto",
            selector: (row) => row.Project,
            sortable: true,
            width: "250px",
        },
        {
            name: "Gobernación",
            selector: (row) => row.Gobernacion,
            sortable: true,
            width: "370px",
        },
        {
            name: "Ruta Inicial",
            selector: (row) => row.RutaIni,
            sortable: true,
            width: "150px",
        },
        {
            name: "Ruta Final",
            selector: (row) => row.RutaFin,
            sortable: true,
            width: "150px",
        },
        {
            name: "Fecha Entrega",
            selector: (row) => row.FechaEntrega,
            sortable: true,
            width: "250px",
        },
    ];

    return (
        <div className="container mt-4">
            <h2>Consolidado de Insumos por Servicios</h2>

            {error && <div className="alert alert-danger">{error}</div>}
            <div className="row">                
                {/* Campo de Artículo Actual con lista desplegable con búsqueda */}
                <div className="col-md-3">
                    <label>Tipo de Servicio:</label>
                    <Select
                        options={servicesType}
                        value={serviceType}
                        onChange={setserviceType}
                        placeholder="Seleccione un Servicio..."
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-5">
                    <label>Código de Proyecto:</label>
                    <Select
                        options={projects}
                        value={project}
                        onChange={setproject}
                        placeholder="Seleccione un proyecto..."
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-2">
                    <label>Fecha de Entrega:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={entDate}
                        onChange={(e) => setEntDate(e.target.value)}
                    />
                </div>
                <div className="col-md-2">
                    <label>Ruta:</label>
                    <input
                        type="number"
                        className="form-control"
                        value={start_route}
                        onChange={(e) => setStartRoute(e.target.value)}
                    />
                </div>
            </div>

            <button className="btn btn-success mt-2" onClick={fetchInsumos}>Obtener Consolidado</button>
            <button className="btn btn-primary mt-2 ml-2" onClick={exportarPDF} disabled={loading || !setOrders} > {loading ? "Generando..." : "Imprimir Consolidado"}</button>
            <DataTable
                columns={columns}
                data={filteredOrders}
                expandableRows
                expandableRowsComponent={ExpandedComponent}
                expandableRowExpanded={() => true}
                pagination
            />
        </div>
    );
};

export default PlanifLines;
